// здесь хранятся стандартные объекты настрйоки и прочее
export default {
	namespaced: true,
	state: {
	},
	getters: {
        swiperOption: state => paginationEl => {
            return {
                autoHeight: true,
                slidesPerView: 1,
                spaceBetween: 24,
                threshold: 10,
                pagination: {
                    el: paginationEl,
                    dynamicBullets: true
                }
            }
        }
	},
	mutations: {
	},
	actions: {
	}
};


// WEBPACK FOOTER //
// ./src/store/modules/standartObjects.js